import { Box } from "@mui/material"
import React from "react"
import GroupTabs from "../GroupTabs"

const GroupOverviewBox = ({ updatePracticeStatus }: any) => {
  return (
    <Box
      sx={{
        // width: " 797px",
        // height: " 707px",
        height: "100%",
        boxShadow: "0px 2px 8px #00000022",
        borderRadius: "4px",
      }}
    >
      <GroupTabs updatePracticeStatus={updatePracticeStatus} />
    </Box>
  )
}

export default GroupOverviewBox
